'use client'

import { Body, H6 } from '@material-bank/mb3-components'
import { ReactNode } from 'react'

// The icon in a circle, title and optional line that head the PDP's small
// sheets: the sign-in prompts and the pricing email.
type StepIntroProps = {
  title: string
  icon: ReactNode
  description?: string
}

export function StepIntro({ title, icon, description }: StepIntroProps) {
  return (
    <>
      <span className="flex h-12 w-12 items-center justify-center overflow-hidden rounded-full bg-white text-foreground shadow-xs ring-1 ring-border">
        {icon}
      </span>
      <div className="flex flex-col items-center gap-1 text-center">
        <H6 className="text-foreground font-medium">{title}</H6>
        {description ? (
          <Body variant="small" className="text-muted-foreground">
            {description}
          </Body>
        ) : null}
      </div>
    </>
  )
}
